import React from 'react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleHeader
} from '../../../../../components/Collapsible';
import { FilterClass } from '../../Filter';
import PropTypes from 'prop-types';
import { FilterClassProptypes } from '../../Filter/FilterClass';

const CollapsibleClass = ({
  facets,
  handleDataChange,
  multiFacetedBoatTypeClass,
  params,
  position,
  tracking,
  label
}) => {
  return (
    <CollapsibleContent initialState="open">
      <CollapsibleHeader priority={0}>{label}</CollapsibleHeader>
      <Collapsible>
        <FilterClass
          facets={facets}
          handleDataChange={handleDataChange}
          multiFacetedBoatTypeClass={multiFacetedBoatTypeClass}
          params={params}
          position={position}
          tracking={tracking}
        />
      </Collapsible>
    </CollapsibleContent>
  );
};
CollapsibleClass.propTypes = {
  ...FilterClassProptypes,
  label: PropTypes.string
};

export { CollapsibleClass };
